import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheckIcon, XIcon } from 'lucide-react';
export const AnonymisedModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  const close = () => setIsOpen(false);
  return <AnimatePresence data-id="element-5">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/50 backdrop-blur-sm print:hidden" role="dialog" aria-modal="true" aria-labelledby="anonymised-modal-title" onClick={close} data-id="element-6">
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.98
      }} transition={{
        type: 'spring',
        stiffness: 220,
        damping: 22
      }} className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-7">
            <button onClick={close} className="absolute top-4 right-4 p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" aria-label="Close" data-id="element-8">
              <XIcon className="h-4 w-4" data-id="element-9" />
            </button>

            <div className="p-8" data-id="element-10">
              <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#1E90FF]/10 mb-5" data-id="element-11">
                <ShieldCheckIcon className="h-6 w-6 text-[#1E90FF]" data-id="element-12" />
              </div>

              <h2 id="anonymised-modal-title" className="text-xl font-bold text-gray-900 mb-3" data-id="element-13">
                Anonymised Case Study
              </h2>

              <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-14">
                This report is based on a real ATL Resonance measurement. Client
                details have been removed to protect confidentiality. All data,
                methodology, and findings are authentic.
              </p>

              <button onClick={close} className="w-full bg-[#1E90FF] text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#1E90FF]/90 transition-colors shadow-sm shadow-blue-200" type="button" data-id="element-15">
                View Report
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};